import { useNavigate } from "react-router-dom";
import styled from "styled-components";

const Background = styled.div`
    width: 100%;
    height: 100dvh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    box-sizing: border-box;
    padding: 24px;
    background-color: #242D34;
    color: #fff;
    text-align: center;
`;

const Logo = styled.img`
    width: 180px;
    max-width: 60%;
    margin-bottom: 8px;
`;

const Code = styled.h1`
    margin: 0;
    font-size: 6rem;
    font-weight: 700;
    line-height: 1;
`;

const Title = styled.h2`
    margin: 0;
    font-size: 1.75rem;
    font-weight: 600;
`;

const Message = styled.p`
    margin: 0;
    max-width: 420px;
    font-size: 1rem;
    color: rgba(255, 255, 255, 0.75);
`;

const HomeButton = styled.button`
    margin-top: 12px;
    padding: 12px 28px;
    border: none;
    border-radius: 8px;
    background-color: #007bff;
    color: #fff;
    font-size: 1rem;
    font-weight: 600;
    cursor: pointer;
    transition: background-color 0.2s ease;

    &:hover {
        background-color: #0069d9;
    }
`;

const NotFound = () => {

    const navigate = useNavigate();

    const goHome = () => {

        navigate("/");

    }

    return (
        <Background>
            <Logo src="/Images/Logo.png" alt="Palmont" />
            <Code>404</Code>
            <Title>Página não encontrada</Title>
            <Message>
                A página que você está procurando não existe ou foi movida.
            </Message>
            <HomeButton onClick={ goHome }>
                Voltar para a tela inicial
            </HomeButton>
        </Background>
    )

}

export default NotFound;
